import React, { useContext, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { EventsSection } from '../components/EventsSection';
import { LanguageContext } from '../components/LanguageContext';
import axios from 'axios';
import hm from '../images/hm.png';
import img50 from '../images/50_years.png';
import pressNotePdf from '../data/Urdu Press Note 2026.pdf';

const Home = () => {
  const { language } = useContext(LanguageContext);
  const [coverPhoto, setCoverPhoto] = useState(null);
  const [carouselImages, setCarouselImages] = useState([]);
  const [magazines, setMagazines] = useState([]);
  const [formCategories, setFormCategories] = useState([]);

  function getCSRFToken() {
    return window.CSRF_TOKEN || '';
  }
  
  useEffect(() => {
    const csrfToken = getCSRFToken();
  
    const fetchCoverPhoto = async () => {
      try {
        const response = await axios.get("/api/homepage/get/cover", {
          headers: {
            "X-CSRFToken": csrfToken,
          },
          skipInterceptor: true,
        });
        setCoverPhoto(response.data.cover_photo);
      } catch (error) {
        console.error("Error fetching cover photo:", error);
      }
    };
  
    const fetchCarouselImages = async () => {
      try {
        const response = await axios.get("/api/homepage/get/carousel", {
          headers: {
            "X-CSRFToken": csrfToken,
          },
          skipInterceptor: true,
        });
        setCarouselImages(response.data);
      } catch (error) {
        console.error("Error fetching carousel images:", error);
      }
    };
  
    const fetchMagazines = async () => {
      try {
        const response = await axios.get("api/homepage/get/magazines", {
          headers: {
            "X-CSRFToken": csrfToken,
          },
          skipInterceptor: true,
        });
        setMagazines(response.data);
      } catch (error) {
        console.error("Error fetching magazines:", error);
      }
    };
  
    const fetchFormCategories = async () => {
      try {
        const response = await axios.get("/api/get/form-categories", {
          headers: {
            "X-CSRFToken": csrfToken,
          },
          skipInterceptor: true,
        });
        setFormCategories(response.data);
      } catch (error) {
        console.error("Error fetching form categories:", error);
      }
    };
  
    fetchCoverPhoto();
    fetchCarouselImages();
    fetchMagazines();
    fetchFormCategories();
  }, []);

  return (
    <>
      {/* Marquee Notification - green border, no background, logo moves with text */}
      <style>{`
        @keyframes marquee-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .marquee-wrapper {
          border: 3px solid #22c55e;
          overflow: hidden;
          background: #f9fafb;
        }
        .marquee-inner {
          display: flex;
          align-items: center;
          animation: marquee-scroll 40s linear infinite;
          white-space: nowrap;
          gap: 2rem;
        }
        .marquee-inner:hover {
          animation-play-state: paused;
        }
        .marquee-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          flex-shrink: 0;
        }
      `}</style>
      <a href={pressNotePdf} target="_blank" rel="noopener noreferrer" className="block">
        <div className="marquee-wrapper py-4">
          <div className="marquee-inner">
            <div className="marquee-item">
              <img src={img50} alt="Urdu Academy Press Note 2026" className="h-16 w-auto rounded shadow-sm" />
              <span className="text-lg font-semibold text-gray-800">
                {language === 'en' 
                  ? 'Urdu Academy Press Note 2026' 
                  : 'اردو اکادمی پریس نوٹ 2026'}
              </span>
            </div>
            <div className="marquee-item">
              <img src={img50} alt="Urdu Academy Press Note 2026" className="h-16 w-auto rounded shadow-sm" />
              <span className="text-lg font-semibold text-gray-800">
                {language === 'en' 
                  ? 'Urdu Academy Press Note 2026' 
                  : 'اردو اکادمی پریس نوٹ 2026'}
              </span>
            </div>
            <div className="marquee-item">
              <img src={img50} alt="Urdu Academy Press Note 2026" className="h-16 w-auto rounded shadow-sm" />
              <span className="text-lg font-semibold text-gray-800">
                {language === 'en' 
                  ? 'Urdu Academy Press Note 2026' 
                  : 'اردو اکادمی پریس نوٹ 2026'}
              </span>
            </div>
            <div className="marquee-item">
              <img src={img50} alt="Urdu Academy Press Note 2026" className="h-16 w-auto rounded shadow-sm" />
              <span className="text-lg font-semibold text-gray-800">
                {language === 'en' 
                  ? 'Urdu Academy Press Note 2026' 
                  : 'اردو اکادمی پریس نوٹ 2026'}
              </span>
            </div>
            <div className="marquee-item">
              <img src={img50} alt="Urdu Academy Press Note 2026" className="h-16 w-auto rounded shadow-sm" />
              <span className="text-lg font-semibold text-gray-800">
                {language === 'en' 
                  ? 'Urdu Academy Press Note 2026' 
                  : 'اردو اکادمی پریس نوٹ 2026'}
              </span>
            </div>
            <div className="marquee-item">
              <img src={img50} alt="Urdu Academy Press Note 2026" className="h-16 w-auto rounded shadow-sm" />
              <span className="text-lg font-semibold text-gray-800">
                {language === 'en' 
                  ? 'Urdu Academy Press Note 2026' 
                  : 'اردو اکادمی پریس نوٹ 2026'}
              </span>
            </div>
            <div className="marquee-item">
              <img src={img50} alt="Urdu Academy Press Note 2026" className="h-16 w-auto rounded shadow-sm" />
              <span className="text-lg font-semibold text-gray-800">
                {language === 'en' 
                  ? 'Urdu Academy Press Note 2026' 
                  : 'اردو اکادمی پریس نوٹ 2026'}
              </span>
            </div>
            <div className="marquee-item">
              <img src={img50} alt="Urdu Academy Press Note 2026" className="h-16 w-auto rounded shadow-sm" />
              <span className="text-lg font-semibold text-gray-800">
                {language === 'en' 
                  ? 'Urdu Academy Press Note 2026' 
                  : 'اردو اکادمی پریس نوٹ 2026'}
              </span>
            </div>
          </div>
        </div>
      </a>

      {/* Thin Notification Banner for Available Application Forms */}
      {formCategories.length > 0 && (
        <Link
          to="/form-applications"
          className={`block bg-blue-50/90 hover:bg-blue-100/90 border-b border-blue-200 transition-colors ${language === 'ur' ? 'rtl' : 'ltr'}`}
        >
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-3">
            <div className={`flex flex-col sm:flex-row items-center justify-between gap-2 ${language === 'ur' ? 'text-right' : 'text-left'}`}>
              <div className="flex items-center gap-3">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-bold bg-blue-800 text-white tracking-wide uppercase">
                  <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse"></span>
                  {language === 'en' ? 'Notice' : 'اطلاع'}
                </span>
                <p className="text-sm sm:text-base font-semibold text-blue-900">
                  {language === 'en'
                    ? `Available Application Forms (${formCategories.length})`
                    : `دستیاب درخواست فارم (${formCategories.length})`}
                  <span className="hidden md:inline font-normal text-blue-700 ml-2">
                    {language === 'en' ? '— Click to view and apply' : '— دیکھنے اور درخواست دینے کے لیے کلک کریں'}
                  </span>
                </p>
              </div>
              <div className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold text-blue-800">
                <span>{language === 'en' ? 'View Forms' : 'فارم دیکھیں'}</span>
                <svg className={`w-4 h-4 ${language === 'ur' ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </div>
          </div>
        </Link>
      )}


      {/* Mission Section */}
           <section className={`py-6 md:py-12 bg-gray-50 ${language === 'ur' ? 'rtl' : 'ltr'}`}>
        <div className="container mx-auto px-8">
          <div className={`flex flex-col md:flex-row items-center gap-12 ${language === 'ur' ? 'text-right' : 'text-left'}`}>
            <div className="flex-1">
              <h2 className="text-3xl font-bold text-blue-800 mb-6">
                {language === 'en' ? "Our Mission" : "ہمارا مقصد"}
              </h2>
              <p className="text-gray-600 mb-4">
                {language === 'en' 
                  ? "The AP State Urdu Academy is committed to preserving and promoting the rich cultural heritage of the Urdu language. Our mission is to create an inclusive environment that fosters learning, creativity, and cultural exchange." 
                  : "اے پی اسٹیٹ اردو اکیڈمی اردو زبان کے ثقافتی ورثے کو محفوظ رکھنے اور فروغ دینے کے لئے وقف ہے۔ ہمارا مقصد ایک جامع ماحول پیدا کرنا ہے جو سیکھنے، تخلیقی صلاحیتوں، اور ثقافتی تبادلے کو فروغ دیتا ہے۔"}
              </p>
              <p className="text-gray-600 mb-4">
                {language === 'en' 
                  ? "We strive to make Urdu education accessible to all, maintain its literary traditions, and create opportunities for scholars and students alike to engage with this beautiful language." 
                  : "ہم اردو تعلیم کو سب کے لئے قابل رسائی بنانے، اس کی ادبی روایات کو برقرار رکھنے، اور اسکالرز اور طلباء کے لئے مواقع پیدا کرنے کی کوشش کرتے ہیں۔"}
              </p>
              <Link to="/about-us" className="bg-blue-800 hover:bg-blue-900 text-white px-6 py-3 rounded-md font-medium transition-colors">
                {language === 'en' ? "Learn More" : "مزید جانیں"}
              </Link>
            </div>
            <div className="flex-1">
              <img 
                src= {hm}
                alt="Mission" 
                className="rounded-lg shadow-lg w-full object-cover" 
              />
            </div>
          </div>
        </div>
      </section>


      {/* Events Section */}
      <EventsSection events={carouselImages} language={language} />

      {/* Magazines Section */}
      <section className="pb-6 md:pb-12 bg-gray-50">
        <div className="container mx-auto px-8">
          <h2 className="text-3xl font-bold text-blue-800 mb-6 text-center">
            {language === 'en' ? "Our Magazines" : "ہمارے رسالے"}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {magazines.length > 0 ? (
              magazines.map((magazine) => (
                <div key={magazine.id} className="rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
                  <div className="p-4">
                    <div className="aspect-w-3 aspect-h-4 mb-4">
                      <img src={magazine.image} alt={magazine.title_EN} className="w-full h-full object-cover rounded" />
                    </div>
                    <h3 className="font-semibold text-lg mb-2">
                      {language === 'en' ? magazine.title_EN : magazine.title_UR}
                    </h3>
                    <a href={magazine.pdf} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                      {language === 'en' ? "Read Magazine" : "رسالہ پڑھیں"}
                    </a>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full rounded-lg p-8 text-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {language === 'en' ? "Stay Tuned!" : "جلد آرہا ہے!"}
                </h3>
                <p className="text-gray-600">
                  {language === 'en' 
                    ? "New magazines coming soon." 
                    : "نئے رسالے جلد آرہے ہیں۔"
                  }
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
